module.exports = __webpack_public_path__ + "static/media/a6.cf1107c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chenlong/a6.mp3
// module id = Znrr
// module chunks = 0